import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import TwitterSvg from 'assets/svg/twitter.svg';
import FacebookSvg from 'assets/svg/facebook.svg';

export const TwitterLoginComponent = props => {
  const [email, setEmail] = useState('');

  const onSubmit = e => {
    e.preventDefault();
  };

  return (
    <>
      <div className="login-banner">
        <h3 className="login-banner__title">
          <span> Never </span> lose sight of your discussions
        </h3>

        <h4 className="login-banner__subtitle">
          <span className="">Create or become part of what's next.</span>
        </h4>
      </div>

      <div className="nshare-wrapper-inner">
        <a href="#" className="promote-list-item">
          <div className="promote-list-img">
            <div className="promote-list-img-inner">
              <img src={TwitterSvg} alt="" />
            </div>
          </div>
          <div className="promote-list-content">
            <div className="promote-list-content-inner">
              <div className="content-title">Continue with Twitter</div>
              <div className="content-text">
                We won't post anything without asking
              </div>
            </div>
          </div>
        </a>
        <a href="#" className="promote-list-item">
          <div className="promote-list-img">
            <div className="promote-list-img-inner">
              <img src={FacebookSvg} alt="" />
            </div>
          </div>
          <div className="promote-list-content">
            <div className="promote-list-content-inner">
              <div className="content-title">Continue with Facebook</div>
              <div className="content-text">
                We won't post anything without asking
              </div>
            </div>
          </div>
        </a>
      </div>
      <form onSubmit={onSubmit} className="hide">
        <div className="form__group">
          <label className="form__label" htmlFor="email">
            Email Address
          </label>

          <input
            className="form__field"
            type="email"
            name="email"
            id="email"
            placeholder="Enter your email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        <div className="form__buttons">
          <button className="button button__transparent button__uppercase">
            <span className="">Continue</span>
          </button>
        </div>
      </form>

      <div>
        <p className="login__tp">
          By using Treadie, you agree to our{' '}
          <Link to="/terms">
            <span>Terms</span>
          </Link>
          &{' '}
          <Link to="/privacy">
            <span>Privacy</span>
          </Link>
        </p>
      </div>
    </>
  );
};

TwitterLoginComponent.propTypes = {
  login: PropTypes.bool,
  signup: PropTypes.bool
};
